module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"pagination_label":"<span class=\\"total _bold\\"> %{total}</span> 件中 %{start}-%{end}件を表示"}}')
  delete Component.options._Ctor
}
